// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBuNac53T91ZaJ64weFI3hut79rcsAHTgg",
  authDomain: "the-movie-tracker-55432.firebaseapp.com",
  projectId: "the-movie-tracker-55432",
  storageBucket: "the-movie-tracker-55432.firebasestorage.app",
  messagingSenderId: "579890186609",
  appId: "1:579890186609:web:293f6bf54b0c00466b0ed0",
  measurementId: "G-12H2NR9P26"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { analytics, auth, db };